import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import moment from "moment";
import { Roles } from "../enums/Roles";

const company = store.getters.company;
let path = `company/${company.companyGuid}/sites`;
const user = store.getters.loggedInUser;
const site = store.getters.site;
const group = store.getters.group;
if(user.role === Roles.AGMSAdmin) {
  path = `company/`
}else if(user.role === Roles.PartnerAdmin) {
  path = `company/`
}else if(user.role === Roles.CompanyAdmin) {
  path = `company/${company.companyGuid}/sites`
}else if(user.role === Roles.SiteAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups`
}else if(user.role === Roles.GroupAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups/${group.key}/computers`
}

const data = {
  readyToUseFilters: {},
  filter: {
    searchResult: true,
    searchText: true,
    noDateSelect: true,
    title: "newcomfilter",
    pageName: "ComputerPageFilter",
    genre: "computerPageFilter",
    filters: [
      {
        title: "companySiteGroup",
        type: "siteAndGroup",
        vmodel: "",
        apiEquivalent: "GroupGuids",
        selectType: 'multiple',
        param: "name",
        data: [],
      },
      {
        title: "computername",
        type: "computer",
        vmodel: "",
        apiEquivalent: "ComputerGuid",
        param: "name",
        data: [],
      },
      {
        title: "operationsys",
        type: "select",
        vmodel: null,
        param: "osName",
        apiEquivalent: "os",
        source: "Defination/GetOsList",
        data: [],
      },
      {
        title: "agentversion",
        type: "wordstyped",
        apiEquivalent: "agentversion",
        param: "username",
      },
      {
        title: "policyversion",
        type: "wordstyped",
        apiEquivalent: "policyversion",
        param: "username",
      },
      {
        title: "protectionStatus",
        type: "select",
        param: "protectionStatusFilter",
        vmodel: "",
        apiEquivalent: "protectionStatusFilter",
        placeholder: "Select Protection Status",
        data: [
          {
            id: "Unknown",
            protectionStatusFilter: "Unknown",
          },
          {
            id: "Protection On, TamperGuard On",
            protectionStatusFilter: "Protection On, TamperGuard On",
          },
          {
            id: "Protection Off, TamperGuard Off",
            protectionStatusFilter: "Protection Off, TamperGuard Off",
          },
          {
            id: "Protection Off",
            protectionStatusFilter: "Protection Off",
          },
          {
            id: "TamperGuard Off",
            protectionStatusFilter: "TamperGuard Off",
          },
          {
            id: "Global Discovery On",
            protectionStatusFilter: "Global Discovery On",
          }
        ],
      },
    ],
    savedFilter: {
      columns: [
        {
          label: "savedcomputerfilters",
          field: "title",
          sortable: false,
        },
        {
          label: "",
          sortable: false,
          components: [
            {
              component: "tableLoadComponent",
              emit: "computerLoad",
            },
          ],
        },
      ],
      rows: [],
      total: 5,
      sortable: {
        order: "filtername",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
    },
  },
  header: {
    navigation: [
      {
        title: "endpoints",
        icon: "drak_computer",
        active: true,
        url: "computers/all",
      },
      {
        title: "browseassets",
        icon: "breadcrumb",
        url: path,
      },
      {
        title: "usersbycomputer",
        icon: "group",
        url: "users-by-computers",
      },
    ],
    buttonPosition: "pr-4 justify-content-between",
    buttons: [],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "endpointHostName",
          field: "WindowsComputerName",
          sortable: true,
          width: '180px',
          components: [
            {
              component: "rowRouter",
              key: "WindowsComputerName",
              route: function (row: any) {
                let url = '#';
                if(row && !row.isDeleted) {
                  url = `/endpoints/company/${row.companySiteGroupInfo.companyGuid}/sites/${row.companySiteGroupInfo.siteGuid}/groups/${row.companySiteGroupInfo.groupGuid}/computers/${row.ComputerId}`;
                }
                return url;
              },
              truncate: {
                position: "middle",
                first: 6,
                last: 6,
              },
              displayField: "WindowsComputerName",
            },
          ],
        },
        // {
        //   label: "computername",
        //   field: "windowsComputerName",
        //   excelField: "WindowsComputerName",
        //   width: "200px",
        //   sortable: false,
        //   display: function (row) {
        //     const companyGuid = row.companySiteGroupInfo.companyGuid;
        //     const siteGuid = row.companySiteGroupInfo.siteGuid;
        //     const groupGuid = row.companySiteGroupInfo.groupGuid;
        //     return `<a href="}" class="is-rows-el name-btn">${row.WindowsComputerName}</a>`;
        //   },
        // },
        {
          label: "Site",
          display: function (row: { companySiteGroupInfo: { siteName: any } }) {
            const siteName = `${row.companySiteGroupInfo.siteName}`;
            return siteName;
          },
          truncate: {
            position: "middle",
            tooltipPosition: "left",
            first: 6,
            last: 6,
          },
        },
        {
          label: "Group",
          display: function (row: {
            companySiteGroupInfo: { groupName: any };
          }) {
            const groupName = `${row.companySiteGroupInfo.groupName}`;
            return groupName;
          },
        },
        {
          label: "lastreported",
          sortable: true,
          excelField: "updatedAt",
          components: [
            {
              component: "tableDateFormatter",
              field: "updateAt",
            },
          ],
          field: "UpdatedAt",
          
        },
        {
          label: "lastipv4v6",
          sortable: false,
          width: '200px',
          display: function (row: any) {
            return `<div class="d-flex align-items-start flex-column"><span> ${row.LastIPv4}</span> <span> ${row.LastIPv6}</span></div>`
          },
        },
        {
          label: "operationsys",
          field: "hostOperatingSystemName",
          excelField: "hostOperatingSystemName",
          sortable: false,
        },
        {
          label: "agentversion",
          field: "AgentVersion",
          excelField: "AgentVersion",
          sortable: false,
        },
        {
          label: "policyversion",
          field: "PolicyFileVersion",
          excelField: "PolicyFileVersion",
          width: '80px',
          sortable: false,
        },
        {
          label: "eventcount",
          field: "eventCount",
          format: 'number',
          width: '80px',
          excelField: "eventCount",
          sortable: false,
        },
        {
          label: "malicioushashes",
          field: "maliciousHashCount",
          format: 'number',
          width: '80px',
          excelField: "maliciousHashCount",
          sortable: false,
        },
        {
          label: "protectionStatus",
          field: "LastProtectionStatus",
          width: '90px',
          excelField: "LastProtectionStatus",
          sortable: false,
        },

        {
          label: "",
          field: "edit",
          width: '80px',
          components: [
            {
              component: "tableOtpComponent",
              class: "mr-2 ml-2",
            },
          ],
        },
        {
          label: "",
          field: "edit",
          width: '80px',
          components: [
            {
              component: "tableDeleteComponent",
              class: "mr-2 ml-2",
              idField: "ComputerId",
              checkDelete: "isDeleted"
            },
          ],
        },
      ],
      rows: [],
      total: 0,
      sortable: {
        order: "",
        sort: "asc",
      },
      page: 1,
      pageSize: 10,
      isLoading: true,
      dateFilter: false,
      hasShowDeleted: true,
      fetchTable: async (options: any) => {
        const filters = data.readyToUseFilters;
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_COMPUTER_LIST, body);
      },
    },
  },
};

export default data;
